import React from "react";
import Section from "../Section";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import { pageTitle } from "../../helpers/PageTitle";

export default function Corporate() {
  pageTitle("Corporate");
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/about/banner_bg.jpg"
        imgUrl="/images/doctors/banner_img.png"
        title="Welcome to <br />Celbion Corporate"
        subTitle="Discover our mission, values and corporate initiatives"
      />

      <Section topMd={140} topLg={120} topXl={100} bottomMd={80} bottomLg={80}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="cs_video_box cs_text_center">
                <h2 className="cs_mb_30">Corporate Video</h2>
                <div
                  style={{
                    position: "relative",
                    paddingBottom: "56.25%",
                    height: 0,
                  }}
                >
                  <iframe
                    src="https://www.youtube.com/embed/-Ftg5mSK9LA"
                    title="Corporate Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      borderRadius: 8,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
